import React from 'react'

const Help = () => {
  return (
    <div style={{ color: 'white' }}></div>
  )
}

export default Help